import React, { FC } from 'react';
import styles from './ErrorContainer.module.css';
import { useState } from '../../state/store';

interface ErrorContainerProps {}

const ErrorContainer: FC<ErrorContainerProps> = () => {
  const { generalError } = useState('generalError');
  return (
    <div className={styles.ErrorContainer} data-testid="ErrorContainer">
      {generalError && <div className={'p-5 text-center bg-red-300 text-red-600'}>{`${generalError}`}</div>}
    </div>
  );
};

export default ErrorContainer;
